module.exports = __webpack_public_path__ + "static/media/tutorial-macros-step4.c422964a.png";